import { useEffect } from 'react';
import { EventsBannerType } from 'store/ducks/eventsBanner';
import { format } from 'date-fns';

import DomainSettingService from 'services/domainSetting.service';
import keycloak from 'utils/keycloak';

export function useEventsBanner(dispatch: Function, isBannerActive: boolean) {

  const _domainSettingService = new DomainSettingService();

  useEffect(() => {
    if (keycloak.token && !isBannerActive) {

      _domainSettingService
        .get(undefined, undefined, undefined, {
          and: [
            { identifier: { eq: "EventsBannerSettings" } },
            { enabled: { eq: true } },
          ],
        })
        .then((result) => {
          if (result && result.data && result.data.length > 0) {

            const jsonBanner: EventsBannerType = JSON.parse(result.data[0].value);

            if (result.data[0].enabled &&
              new Date() >= new Date(jsonBanner.start_date) &&
              new Date() <= new Date(jsonBanner.end_date)
            ) {
              dispatch({
                type: 'SET_EVENTS_BANNER',
                data: jsonBanner
              });
            }
          }
        });
    }
  }, [keycloak.token]);
}